import React, { useState } from "react";
import { Collapse, Table, Button, Select, Upload } from "antd";

import OrderHistory from "./OrderHistory";
import AppointmentManagerDashboard from "./AppointmentManager";
import ServiceManagement from "./ServiceManagement";
const { Panel } = Collapse;
const { Option } = Select;

const LabTestDashboard = () => {
  return (
    <div className="labtest-dashboard">
      <div style={{ margin: "20px" }}>
        <Collapse accordion>
          <Panel header="Service Management" key="1">
            <ServiceManagement />
          </Panel>
          <Panel header="Appointment Manager" key="2">
            <AppointmentManagerDashboard />
          </Panel>
          <Panel header="Order History" key="3">
            <OrderHistory />
          </Panel>
        </Collapse>
      </div>
    </div>
  );
};

export default LabTestDashboard;
